module.exports = __webpack_public_path__ + "static/media/img8.b4e53f4a.jpg";